(ns practitest.frontend.import-ticket-modal.subs
  (:require
    [re-frame.core :as re-frame]))

(re-frame/reg-sub
  ::import-modal
  (fn [db [_]]
    (:import-modal db)))

(re-frame/reg-sub
  ::show-import-from-bugtracker-modal?
  :<- [::import-modal]
  (fn [import-modal [_]]
    (:show-import-from-bugtracker-modal? import-modal)))

(re-frame/reg-sub
  ::get-import-modal-select-field-value
  :<- [::import-modal]
  (fn [import-modal [_ field-id]]
    (get-in import-modal [:fields field-id])))

(re-frame/reg-sub
  ::get-import-modal-checkbox-field-value
  :<- [::import-modal]
  (fn [import-modal [_ field-id]]
    (get-in import-modal [:fields field-id :value])))

(re-frame/reg-sub
  ::get-import-modal-text-field-value
  :<- [::import-modal]
  (fn [import-modal [_ field-id]]
    (get-in import-modal [:fields field-id :value])))

(re-frame/reg-sub
  ::get-import-modal-jira-filters
  :<- [::import-modal]
  (fn [import-modal [_]]
    (:jira-filters import-modal)))

(re-frame/reg-sub
  ::get-import-modal-notifications
  :<- [::import-modal]
  (fn [import-modal [_]]
    (:import-modal-notifications import-modal)))
